import { lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './layouts/Layout';
import ToastContainer from './components/ToastContainer';
import ProtectedRoute from './routes/ProtectedRoute';
import AdminRoute from './routes/AdminRoute';

const Profile = lazy(() => import('./features/users/pages/Profile'));
const Login = lazy(() => import('./features/auth/pages/Login'));
const Register = lazy(() => import('./features/auth/pages/Register'));
const ResetPassword = lazy(() => import('./features/auth/pages/ResetPassword'));
const ResetPasswordRedirect = lazy(() => import('./features/auth/pages/ResetPasswordRedirect'));
const Dashboard = lazy(() => import('./features/dashboard/pages/Dashboard'));
const Brands = lazy(() => import('./features/brands/pages/Brands'));
const Questionnaire = lazy(() => import('./features/routine/pages/Questionnaire'));
const Products = lazy(() => import('./features/products/pages/Products'));
const ProductDetails = lazy(() => import('./features/products/pages/ProductDetails'));
const AddProduct = lazy(() => import('./features/products/pages/AddProduct'));
const Orders = lazy(() => import('./features/orders/pages/Orders'));
const UserPage = lazy(() => import('./features/users/pages/UserPage'));
const Reports = lazy(() => import('./features/reports/pages/Reports'));
const Questions = lazy(() => import('./features/routine/pages/Questions'));
const CardTypes = lazy(() => import('./features/education/pages/CardTypes'));
const RuleTypes = lazy(() => import('./features/education/pages/RuleTypes'));
const Placements = lazy(() => import('./features/education/pages/Placements'));
const Rules = lazy(() => import('./features/education/pages/Rules'));
const Cards = lazy(() => import('./features/education/pages/Cards'));
const Tags = lazy(() => import('./features/education/pages/Tags'));
const MediaTypes = lazy(() => import('./features/education/pages/MediaTypes'));
const Groups = lazy(() => import('./features/education/pages/Groups'));
const RetailerStores = lazy(() => import('./features/retailers/pages/RetailerStores'));
const Notifications = lazy(() => import('./features/notifications/pages/Notifications'));

export default function App() {
  return (
    <>
      <ToastContainer />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/" element={<ResetPasswordRedirect />} />

        <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/add" element={<AddProduct />} />
          <Route path="/products/:slug" element={<ProductDetails />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/users" element={<UserPage />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/questions" element={<Questions />} />
          <Route path="/questionnaire" element={<Questionnaire />} />
          <Route path="/education/card-types" element={<CardTypes />} />
          <Route path="/education/rule-types" element={<RuleTypes />} />
          <Route path="/education/placements" element={<Placements />} />
          <Route path="/education/rules" element={<Rules />} />
          <Route path="/education/cards" element={<Cards />} />
          <Route path="/education/tags" element={<Tags />} />
          <Route path="/education/media-types" element={<MediaTypes />} />
          <Route path="/education/groups" element={<Groups />} />
          <Route path="/retailers/stores" element={<RetailerStores />} />
          <Route
            path="/notifications"
            element={
              <AdminRoute>
                <Notifications />
              </AdminRoute>
            }
          />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Route>
      </Routes>
    </>
  );
}
